import { useCallback, useEffect, useRef, useState } from 'react'

export function useTimedToggle(duration: number = 2000) {
  const [state, setState] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const trigger = useCallback(() => {
    setState(true)

    if (timeoutRef.current) clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(() => {
      setState(false)
      timeoutRef.current = null
    }, duration)
  }, [duration])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  return [state, trigger] as const
}
